import { CustomTable } from '../../../../components';
import React from 'react';

const PatientRelatedReports = ({ relatedReports }) => {
  const columns = [
    { key: 'name', title: 'Patient Name' },
    { key: 'date', title: 'Date' },
    { key: 'reportName', title: 'Report Type' },
    { key: 'status', title: 'Report Status' },
  ];

  const actions = [
    {
      label: 'more',
      iconName: 'more-icon',
      dropdownItems: [
        {
          id: 'view-report',
          label: 'View Report',
          iconName: 'report-preview',
          onClick: item => {
            window.location.href = `/patientReports/${item?._id}`;
          },
        },
      ],
      onClick: () => {
        // setSelectReportTemplateModal(true);
      },
    },
  ];

  return (
    <div>
      <div
        className="tableWrap"
        style={{ height: '100%', marginBottom: '1rem' }}
      >
        <CustomTable
          actions={actions}
          columns={columns}
          tableData={relatedReports}
          from="reports"
        />
      </div>
    </div>
  );
};

export default PatientRelatedReports;
